import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import OrderDetails from '../../components/OrderDetails'

const ShoppingOrderConfirmationPage = () => {
    return (
        <>
            <Helmet>
                <title>Order Info</title>
            </Helmet>
            <Header confirmPage={true}/>
            <ActiveCatalogue />
            <OrderDetails confirmedOrder={true} />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default ShoppingOrderConfirmationPage